export const CHART_COLORS = [
  '#C8E6A2',
  '#A2E2E6',
  '#94A5FE',
  '#7EA0A7',
  '#FEB085',
  '#C7C6F8',
  '#FEAAAA',
  '#FE9E69',
  '#E59CB9',
  '#CD8086',
];
